<div class="row ba-btn-row">
  <div class="col-12">
    <button type="button" class="ba-btn ba-btn-secondary"
            #buttonElement
            (click)="clickEvent()"
            [disabled]="btnDisabled"
            data-analytics-track="true"
            data-analytics-category="Secondary Button"
            data-analytics-action="Klick"
            attr.data-analytics-name="{{dataAnalyticsName}}"
            data-analytics-value=""
            id="{{_id}}_SpaeterFortsetzen_btn">
      Antrag später fortsetzen
    </button>
  </div>
</div>

<div class="row ba-form-row">
  <div class="col-12">
    <div class="alert alert-info" id="{{_id}}_SpaeterFortsetzen_Text">
      <p>
        Sie können Ihren Antrag jederzeit später fortsetzen. Ihr aktueller Stand wird dabei gespeichert.
      </p>
      <p>
        Zuletzt gespeichert am {{ letzteAenderungAm$ | async | momentDate:"DD.MM.YYYY" }}
        um {{letzteAenderungAm$ | async | momentDate:"HH:mm" }} Uhr.
      </p>
    </div>
  </div>
</div>

<wba-antrag-spaeter-fortsetzen-dialog
  (commitEvent)="routeToFMS()"
    #modalDialog/>
